// extracted by css-extract-rspack-plugin
export default {"ViewButton":"ViewButton-module__ViewButton___gm5S8","active":"ViewButton-module__active___d8uaN"};